export default {
  methods: {
    onLoadTextToSpeech() {
      return new Promise((resolve, reject) => {
        if (typeof $ === 'undefined') {
          reject(null);
        }

        if (window.DE_TTS) {
          resolve(window.DE_TTS);
        } else {
          reject(null);
        }
      });
    },
  },
};
